<template>
  <div id="app">
    <router-view />
    <half-circle-spinner
      v-if="showSpinner"
      :animation-duration="1000"
      :size="30"
      class="auth-ui-main-spinner"
    />
  </div>
</template>
<script>
/* ============
 * Entry Point
 * ============
 *
 * The entry point of the application.
 */
import { HalfCircleSpinner } from 'epic-spinners';

export default {
  name: 'PuheetAuth',

  components: {
    HalfCircleSpinner,
  },

  computed: {
    showSpinner() {
      return this.$store.state.general.showSpinner;
    },
  },
};
</script>
